import { render } from "./R3SystemNoticePopup.vue?vue&type=template&id=1e245cac&scoped=true"
import script from "./R3SystemNoticePopup.vue?vue&type=script&lang=js"
export * from "./R3SystemNoticePopup.vue?vue&type=script&lang=js"

import "./R3SystemNoticePopup.vue?vue&type=style&index=0&id=1e245cac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e245cac"]])

export default __exports__